import { createActions, createReducer } from "reduxsauce";
export const { Types, Creators } = createActions({
    buscarNotasAuditoria: ["payload"],
    buscarNotasAuditoriaSucesso: ["payload"],
    setStatusAuditoria: ["payload"],
    editarObsAuditoria: ["payload"],
    getOcorrencias: ["payload"],
    getOcorrenciasSucesso: ["payload"],
    setLoadAuditoria: ["payload"],
    removerNtsAuditoria: ["payload"],
    agruparNotasAuditoria: ["payload"],
    setNotasModal: [ 'payload' ]
});

const INIT_STATE = {
    notasAuditoria: [],
    notasAgrupadas: [],
    notasModal: [],
    ocorrencias: [],
    loadAuditoria: false,
    teste: []
};

const buscarAuditoriaSucesso = (state = INIT_STATE, action) => {
    const { dados } = action.payload;
    return {
        ...state,
        notasAuditoria: dados
    };
};

const getOcorrenciasSucesso = (state = INIT_STATE, action) => ({
    ...state,
    ocorrencias: action.payload
});

const setLoadAuditoria = (state = INIT_STATE, action) => ({
    ...state,
    loadAuditoria: action.payload
});

const removerNtsAuditoria = (state = INIT_STATE, action) => {
    const { notasAuditoria, notasAgrupadas, notasModal } = state;
    const { id, agrupada } = action.payload;

    const novaLista = notasAuditoria.filter((nota, i) => nota._id !== id);
    const novaListaAgrupada = notasAgrupadas;

    if (agrupada) {
        for (let index in notasAgrupadas[agrupada]) {
            const nota = notasAgrupadas[agrupada][index];

            if (nota._id === id) {
                delete notasAgrupadas[agrupada][index];
            }
        }
    }

    let newModalNotas = notasModal.filter((nota, i) => nota.item._id !== id);

    return {
        ...state,
        notasAuditoria: novaLista,
        novaListaAgrupada: novaListaAgrupada,
        notasModal: newModalNotas
    };
};

const agruparNotasAuditoria = (state = INIT_STATE, action) => {
    const { notas } = action.payload;

    return {
        ...state,
        notasAgrupadas: notas
    };
};

const setNotasModal = (state = INIT_STATE, action) => {
    const { notas } = action.payload;

    let itensNotas = [];
    if (notas) {
        itensNotas = notas.map(nota => {
            let images = [];
            let notaFil = nota.historico
                ? nota.historico.filter(item => item.cam_imagem).reverse()
                : [];
            notaFil.forEach(item => {
                if (Array.isArray(item.cam_imagem))
                    item.cam_imagem.forEach(x => images.push(x));
            });
            return {
                images,
                item: nota
            };
        });
    }

    return {
        ...state,
        notasModal: itensNotas
    }
};

export default createReducer(INIT_STATE, {
    [Types.BUSCAR_NOTAS_AUDITORIA_SUCESSO]: buscarAuditoriaSucesso,
    [Types.GET_OCORRENCIAS_SUCESSO]: getOcorrenciasSucesso,
    [Types.SET_LOAD_AUDITORIA]: setLoadAuditoria,
    [Types.REMOVER_NTS_AUDITORIA]: removerNtsAuditoria,
    [Types.AGRUPAR_NOTAS_AUDITORIA]: agruparNotasAuditoria,
    [Types.SET_NOTAS_MODAL]: setNotasModal
});
